export default function getCombinedExercisesData(entry) {
  const warmups = entry?.warmingUpExercise?.constructor.name === 'Array' ? { ...entry.warmingUpExercise } : {}
  const exercises = entry?.exercises?.constructor.name === 'Array' ? { ...entry.exercises } : {}

  const combined = []
  if (warmups[0]) {
    const warmupsArr = Object.values(warmups)
    warmupsArr.forEach((warmup) => {
      const warmupEntry = warmup
      warmupEntry.exerciseType = 'warmup'
      combined.push(warmupEntry)
    })
  }

  if (exercises[0]) {
    const exerciseArr = Object.values(exercises)
    exerciseArr.forEach((exercise) => {
      const exerciseEntry = exercise
      exerciseEntry.exerciseType = 'default'
      combined.push(exerciseEntry)
    })
  }

  if (!exercises[0] && !combined[0]) return false

  return combined
}
